export const highlightedAmenityTypes = [
  {
    id: 'freshSeasonalFare',
    qeId: 'fresh-seasonal-fare',
  },
  {
    id: 'premiumBar',
    qeId: 'premium-bar',
  },
];
